<app-header></app-header>
<mat-card i18n="@@aaacf104b08294fbf293f73d13b923cb5a918f91" *ngIf="!trasllat.potModificar">
    La sol·licitud es troba en un estat de només lectura
</mat-card>
<mat-vertical-stepper [linear]="true" #stepper> 
    <mat-step [completed]="step1component.isValid() && dataService.stepPerformed(1)">
        <ng-template matStepLabel i18n>Dades personals</ng-template>
        <app-dades-personals #step1component [stepper]="stepper"></app-dades-personals>
    </mat-step>
    <mat-step [completed]="step2component.isValid() && dataService.stepPerformed(2)">
        <ng-template matStepLabel i18n>Dades de contacte</ng-template>
        <app-dades-contacte #step2component [stepper]="stepper"></app-dades-contacte>
    </mat-step>                
    <mat-step [completed]="step3component.isValid() && dataService.stepPerformed(3)">
        <ng-template matStepLabel i18n>Estudis</ng-template>
        <app-estudis #step3component [stepper]="stepper"></app-estudis>
    </mat-step>
    <mat-step [completed]="step4component.isValid() && dataService.stepPerformed(4)">
        <ng-template matStepLabel i18n>Documentació</ng-template>
        <app-documentacio #step4component [stepper]="stepper"></app-documentacio>
    </mat-step>                        
    <mat-step [completed]="step5component.isValid() && dataService.stepPerformed(5)" *ngIf="dataService.trasllat.oferta.pagaInscripcio">
        <ng-template matStepLabel i18n>Pagament</ng-template>
        <app-pagament #step5component [stepper]="stepper"></app-pagament>
    </mat-step>
    <mat-step [completed]="step6component.isValid() && dataService.stepPerformed(6)" *ngIf="(!dataService.trasllat.isnew) && (dataService.trasllat.estat!=64)">
        <ng-template matStepLabel i18n="@@17a8882e8f78a211c85de8a1d8376fc95e5f92ce">Estat de la sol·licitud</ng-template>
        <app-confirmacio #step6component></app-confirmacio>
    </mat-step>
</mat-vertical-stepper>


// WEBPACK FOOTER //
// ./src/app/trasllat/trasllat.component.html